/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

const EmptySlot = () => {
    return (
      <div
        className="grid-item empty-slot"
        css={css`
            min-height: 6rem;
            position: relative;
        `}
      >
      </div>
    )
}

export { EmptySlot }
